import $ from 'jquery';
import ReadingPositionIndicator from '../vendor/rpi/rpi.js';


$(document).on('ready', function() {


/* Read progress indicator
********************************************/

if ($('.js-reading-wrapper').length) {
	var rpi;
	setTimeout(function waitUntilDomIsReadyLoadingCustomFontsMightOffsetThis() {
		rpi = new ReadingPositionIndicator({
			rpiArea: '.js-reading-wrapper',
			progressBar: {
				show: true,
			},
			percentage: {
				show: false, // default false
				displayBeforeScroll: false, // default false
			},
		}).init();
	}, 1000);
}


/* Adding class on anchor that contains image
********************************************/

if ($('.c-article').length) {
	$('article p a:has(img), article .wp-caption a:has(img)').addClass('c-article__image-link');
	$('article img').closest('p').addClass('c-article__image-container');
}



});
